<template>
  <section class="sec-top-intro">
    <div class="box-top-slide">
      <div class="img-top-slide">
        <img src="@/assets/img/column/202407_01.jpg" class="only_pc" />
        <img src="@/assets/img/column/202407_01_sp.jpg" class="only_sp" />
      </div>
      <div class="img-top-slide_text">
        <h2 class="mb-0 text-left"><span>夏の肌悩み対策！</span><br>インナードライ肌と保湿の関係性</h2>
      </div>
    </div>
  </section>

  <section class="column_content">
    <h2 class="mt-5 pt-5">夏場になると増えるお肌の悩み<br>その原因は<br>インナードライ肌かも</h2>
    <div class="feature-row">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202407_02.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">夏の肌悩み。紫外線対策だけになってない？</h3>
        <p class="mb-3">みなさんは、夏になると気になるお肌の悩みはなんですか？</p>
        <p class="mb-3">紫外線によるお肌ダメージをはじめ、UVケアに集中する方も多いかもしれません。</p>
        <p class="mb-3">そのほかにも、テカリや皮脂、汗による化粧崩れなど、さまざまな肌悩みがあると思いますが<strong>「夏場の正しいスキンケア」</strong>、できていますか？</p>
        <p class="mb-3">意外なことに<strong>夏の肌悩みの原因で多いのが「乾燥」</strong>です。</p>
        <p>お肌の乾燥と聞くと、冬に多いものと思われがちですが、夏は「紫外線ダメージ」「汗・皮脂の過剰分泌」「エアコンの使用」など、<strong>肌の【インナードライ】</strong>が起きる要因がたくさん潜んでいます。</p>
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">美肌対策のキーワード。インナードライ肌とは？</h3>
        <p class="mb-3">近年注目されている、インナードライ肌。</p>
        <p class="mb-3">通常すこやかな状態の肌では、肌から水分が蒸発することを防ぐ蓋の役割となる皮脂と、角層の内部に水分を貯える天然保湿因子（NMF）などがバランス良く機能しています。</p>
        <p class="mb-3">一方でインナードライ肌とは、表面は皮脂の分泌によりベタついているにもかかわらず、肌の内側は角層の水分量が不足し乾燥している肌状態のこと。</p>
        <p class="mb-3">そして、乾燥だけではなく老化を引き起こす要因の一つともいわれています。</p>
        <p>しかしいざ「インナードライ肌」対策となると具体的にどんな美容アイテムを選べばいいかわからない方も多いかもしれません。</p>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202407_03.jpg">
      </div>
    </div>
    
    <h2 class="my-5 pt-5">夏の保湿ケア<br>夏の肌悩みの原因はインナードライ肌かも？</h2>
    <p class="text-center mb-5 pb-5">今回は20代、30代、40代の一般女性を対象に<br>「インナードライ」に関する調査を実施。<br>一般女性のみなさんに「夏に感じる肌のお悩み」に関してうかがいました。</p>
    <div class="feature-row">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">20代～40代女性の夏の肌悩みは、日焼け、しみ・そばかす、ベタつき。</h3>
        <p class="mb-3">まずは、20代、30代、40代の女性に、夏に感じる肌のお悩みとスキンケアについてうかがいました。</p>
        <p class="mb-3"><strong>「夏に感じる肌の悩み教えてください」</strong></p>
        <p class="mb-3">『日焼け（65.1％）』<br>『しみ・そばかす（53.0％）』<br>『ベタつき（41.6％）』</p>
        <p class="mb-3"><strong>「夏のスキンケアで意識していることを教えてください」</strong></p>
        <p class="mb-3">『紫外線対策の徹底（63.1％）』<br>『保湿（42.7％）』<br>『丁寧なクレンジング（31.8％）』</p>
        <p class="mb-3">やはり夏場特有の「紫外線対策」を重視する方が目立つ結果に！</p>
        <p>続いて、重要なスキンケアとなる保湿や丁寧なクレンジングなど、基礎的なスキンケアを意識する方も多い結果となりました。</p>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202407_04.jpg">
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202407_05.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">紫外線ダメージの1つ、インナードライ肌とは？</h3>
        <p class="mb-3"><strong>「インナードライ肌を知っていますか？」</strong></p>
        <p class="mb-3">70%以上の方が、インナードライの実態に詳しくないようです。</p>
        <p class="mb-3"><strong>「夏に肌の乾燥を感じるのはいつですか？（複数回答可）」</strong></p>
        <p class="mb-3"><strong>『入浴後（24.4％）』<br>『日中（20.6％）』<br>『起床時（17.2％）』</strong></p>
        <p class="mb-3">入浴後はもちろん、やはり生活のどのタイミングでも乾燥を感じる方が多いようです。</p>
        <p class="mb-3">そして夏場はエアコンによる乾燥対策が必要！</p>
        <p class="mb-3">しかし本アンケートの一部からは「夏に保湿ケアをそこまで意識していない」という声も聞こえてきました。</p>
        <p class="mb-3">理由としては「汗をかくなどで、冬場ほど顔の乾燥（痛みやカサつき）を感じないため（20代）」「オイリー肌なので、余計にベタベタする（40代）」など。</p>
        <p>夏に感じる肌の悩みの一つであるベタつきが、夏の保湿ケアを避ける要因となっているようです。</p>
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">保湿もしたいけど、ベタつかず美白効果も求めたい！</h3>
        <p class="mb-3">では夏の保湿ケアアイテムには、具体的にどんな機能が求められているでしょうか。</p>
        <p class="mb-3"><strong>「夏の保湿ケアアイテムに求めるものを教えてください（複数回答可）」</strong></p>
        <p class="mb-3"><strong>『ベタつかない（69.9％）』<br>『美白効果・シミ対策（48.8％）』<br>『テカらない（44.2％）』</strong></p>
        <p class="mb-3">夏の保湿ケアのアイテムには、ベタつきやテカりの少なさを求めつつ、美白効果やシミ対策も重視する方が多いよう。</p>
        <p>なおかつ、刺激が多い夏だからこそ「肌にやさしい」アイテムはうれしいですね。</p>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202407_06.jpg">
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202407_07.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">インナードライ肌の予防のために！紫外線ダメージにはどう対応する？</h3>
        <p class="mb-3">そんな肌の大敵である、夏の紫外線。皆さんはどんな対策を行なっているのでしょうか？</p>
        <p class="mb-3"><strong>「あなたが行っている紫外線対策を教えてください（複数回答可）」</strong></p>
        <p class="mb-3">日焼け止めの活用や、日傘、帽子などを使用し直射日光を避けるといった、紫外線対策を行っているようです。</p>
        <p class="mb-3"><strong>そしてとても重要なのは、紫外線ダメージを受けた後のスキンケア！</strong></p>
        <p class="mb-3">紫外線のダメージを受けた肌はいつも以上に敏感で乾燥しやすくなっていることを、ご存知の方も多い様です。</p>
        <p>美白や美肌の一歩に大切なのは<strong>「いつも以上にしっかりとした保湿ケアをすること」</strong></p>
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">ホワイトニングに有効な「ビタミンC誘導体」は鉄板！</h3>
        <p class="mb-3"><strong>紫外線ダメージを受けた後のスキンケアにはどのような美容成分を求めますか？（複数回答可）</strong></p>
        <p class="mb-3"><strong>『ビタミンC・ビタミンC誘導体（63.2％）』<br>『ヒアルロン酸（18.0％）』<br>『トラネキサム酸（13.3％）』</strong></p>
        <p>ビタミンCは、メラニンの生成抑制やコラーゲンの合成など、透明感のある美肌へ導く成分であることから、紫外線ダメージを受けた肌に対して必要だと感じる方が多くいるようです。</p>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202407_08.jpg">
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202407_09.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3 text-center">夏の肌には<br>インナードライ肌を<br>防ぐためのスキンケアを</h3>
        <p class="mb-3">今回の調査から分かったことは、自分でも気が付かないうちに、インナードライ肌になっている方が一定数いること。</p>
        <p class="mb-3">なぜなら夏の時期も肌の乾燥を感じている方が7割いながらも、肌のべたつきを気にしていると回答した方は約4割程度。</p>
        <p class="mb-3">その理由は紫外線対策を気にしながらも、高い湿度や気温によるベタつきを避けたいと思っている方が多いことも一つの要因かもしれません。</p>
        <p class="mb-3">そんな「インナードライ肌」の解決策としておすすめなのは、季節にあった美容スキンケアアイテムを選ぶこと。</p>
        <p>「軽い使い心地」で「保湿成分」や「美白効果」の効果をもちあわせた保湿美容アイテムを、ぜひ取り入れてみてはいかがでしょうか。</p>
      </div>
    </div>

    <div class="layer_01  mt-5 py-5">
      <img src="@/assets/img/column/layer-bg_01.jpg">
      <div class="layer-text">
        <p class="mb-3">重要なのは、季節にあわせて<br>スキンケア商品の見直しやアイテムを追加すること。</p>
        <p class="mb-3">インナードライ肌への対策として、<br>リッチで美肌に効果的な美容成分<br>「ビタミンＣ・ビタミンＣ誘導体」や<br>「トラネキサム酸」などを含んだ、<br>スキンケアアイテムのぜひ取り入れてみてほしい。</p>
        <p>夏の肌ダメージにも負けない、<br>すこやかで輝く肌を手に入れて。</p>
      </div>
    </div>

    <h2 class="mt-5 pt-5">インナードライ肌におすすめの<br>保湿スキンケアアイテム</h2>
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/special_whiteningessence.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">SPECIAL<br>薬用ホワイトニングエッセンスEX</h3>
        <p class="mb-3">¥5,500</p>
        <p class="mb-3">なめらかで透明感のある肌へ。<br>しっとりとなじむ美白美容液。</p>
        <p class="mb-3">安定した状態で角層の奥まで届き、透明感美肌へ導く、ビタミンC誘導体（L-アスコルビン酸 2-グルコシド）。</p>
        <p class="mb-3">肌あれを防ぐグリチルリチン酸ジカリウム。なめらかな肌へ導く数種の保湿成分。</p>
        <p>すうっと伸びる軽いテクスチャーなのに、とても頼もしい美容液です。</p>
        <div class="mt-5">
          <router-link to="/products" class="btn">
            商品一覧へ
          </router-link>
        </div>
      </div>
    </div>

    <h2 class="my-5">特長成分</h2>
    <div class="text-center">
      <h3 class="mb-3">【L-アスコルビン酸 2-グルコシド】</h3>
      <p class="mb-3">メラニン色素の生成を抑えるとともに、<br>若々しいハリのある肌に導いてくれます。</p>
      <h3 class="mb-3 pt-3">【グリチルリチン酸ジカリウム】</h3>
      <p class="mb-3">肌荒れの炎症の悪化を防ぎ、赤みを抑える効果が期待できます。<br>敏感肌の方にもご使用いただけます。</p>
      <p>※美白：メラニンの生成を抑え、シミ・ソバカスを防ぐ。</p>
    </div>

    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">BASIC<br>マナビス 薬用レストアジェル EXc</h3>
        <p class="mb-3">¥5,500</p>
        <p class="mb-3">軽いつけ心地なのに、しっとり。<br>水分と油分をバランスよく与える乳液。</p>
        <p class="mb-3">「全体的に水分が足りない」「油分が足りない」または、部分的にオイリー肌やドライ肌など、さまざまなタイプの肌へ必要なうるおいをとどけ、落ち着かせます。</p>
        <p>保湿と美白※がワンステップで叶う乳液です。よりみずみずしい美白アイテムがお好みでしたら、薬用ホワイトニングエッセンス EXがおすすめです。</p>
        <div class="mt-5">
          <router-link to="/products" class="btn">
            商品一覧へ
          </router-link>
        </div>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/basic_restorejel.jpg">
      </div>
    </div>

    <h2 class="my-5">特長成分</h2>
    <div class="text-center mb-5 pb-5">
      <h3 class="mb-3">【トラネキサム酸】</h3>
      <p class="mb-3">メラニン生成の指令を抑制する働きがあります。</p>
      <p class="mb-3">抑制することで、透明感のあるお肌へ導きます。</p>
      <p>※美白：メラニンの生成を抑え、シミ・ソバカスを防ぐ。</p>
    </div>
   
    <div class="layer_02">
      <img src="@/assets/img/column/202407_10.jpg">
      <div class="layer-text">
        <div class="layer-text-inner">
          <h2 class="mb-3 text-left"><span>理想の美しさを求めるスペシャルケア</span><br>SPECIALシリーズ</h2>
          <p class="mb-3">理想の美しさは、一人ひとり違います。</p>
          <p class="mb-3">ピンとしたハリ肌。透明感にあふれた肌。</p>
          <p class="mb-3">乾燥による小ジワの目立たない肌。</p>
          <p class="mb-3">あるいは、年齢を感じさせない、<br>輝きに満ちた表情かもしれません。</p>
          <p class="mb-3">思い描くその肌、その表情へ導くアイテム。</p>
          <p class="mb-3">ベーシックケアだけでは足りないものを補うアイテム。</p>
          <p>ゆっくりと鏡に向かい、そっと肌にふれて、<br>まずは、特別な一品を選んでみてください。</p>
        </div>
      </div>
    </div>
    
    <h2 class="mt-5 pt-5">その他SPECIALラインの商品</h2>
    <div class="feature-row feature-row_product_list">
      <div class="feature-row_product_item">
        <router-link to="/products">
          <img src="@/assets/img/column/special_liftserum.jpg">
        </router-link>
        <div class="feature-row_product_detail text-center">
          <div class="feature-row_product_title mb-3">リフトセラム</div>
          <p>4種の「ヒアルロン酸」を贅沢に配合。<br>肌にすうっとなじみ、キメを整えるスペシャルな美容液。</p>
          <div class="my-5">
            <router-link to="/products" class="btn">
              商品一覧へ
            </router-link>
          </div>
        </div>
      </div>
      <div class="feature-row_product_item">
        <router-link to="/products">
          <img src="@/assets/img/column/special_bihakulotion.jpg">
        </router-link>
        <div class="feature-row_product_detail text-center">
          <div class="feature-row_product_title mb-3">薬用美白ローション</div>
          <p>紫外線やブルーライトによる乾燥から守り、肌あれを防ぐ、集中ケア化粧水。</p>
          <div class="my-5">
            <router-link to="/products" class="btn">
              商品一覧へ
            </router-link>
          </div>
        </div>
      </div>
      <div class="feature-row_product_item">
        <router-link to="/products">
          <img src="@/assets/img/column/special_moisturejel.jpg">
        </router-link>
        <div class="feature-row_product_detail text-center">
          <div class="feature-row_product_title mb-3">モイスチャージェル</div>
          <p>乾燥による小ジワの目立たない肌へ。<br>バリア機能を助けるジェル状保湿液。</p>
          <div class="my-5">
            <router-link to="/products" class="btn">
              商品一覧へ
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="text-center mb-5 pb-5">
      <p>アンケートの詳細は以下からご覧いただけます。</p>
      <p><a href="https://prtimes.jp/main/html/rd/p/000000008.000124389.html" target="_blank" title="https://prtimes.jp/main/html/rd/p/000000008.000124389.html">【夏の保湿ケア】夏の肌悩みの原因はインナードライ肌かも？スキンケアアイテムに求められているのは「ベタつかない」「ビタミンC」</a></p>
    </div>

    <div class="rte">
      <font size="1">
        <p>調査概要：「インナードライ」に関する調査<br>
        【調査期間】2024年6月10日（月） ～ 2024年6月11日（火）<br>
        【調査方法】リンクアンドパートナーズが提供する調査PR「PRIZMA」によるインターネット調査<br>
        【調査人数】1,002人<br>
        【調査対象】調査回答時に20～40代女性と回答したモニター<br>
        【モニター提供元】ゼネラルリサーチ<br>
        ※この調査の内容は、あくまでアンケート結果の紹介であり、効果や効能を実証するものではありません。</p>
      </font>
    </div>
  </section>


  <!-- トップに戻るボタン -->
  <button id="page-top" class="btn" v-on:click="scrollTop">
    TOP
  </button>

</template>

<style scoped>
.column_content h2,.column_content h3 {
  font-weight: 500 !important;
}

.feature-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 50px;
}
.feature-row_item_image img {
  width: 100%;
}
.feature-row_item_text h3 {
  font-size: 1.25em;
}

button#page-top {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 100;
}


.layer_01 {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('../../assets/img/column/layer-bg_01.jpg');
  background-size: cover;
  background-position: center;
  min-height: 500px; /* 最小高さを設定しておくと、極端に小さくなるのを防げます */
  padding: 20px; /* テキストと画像の端の間に余白を設定 */
}
.layer_01 img {
  display: none; /* 画像は背景として使用するので非表示にします */
}
.layer_01 .layer-text {
  padding: 10px;
  text-align: center;
  max-width: 90%; /* 文字が画像からはみ出さないように最大幅を設定 */
  word-wrap: break-word; /* 長い単語が折り返されるようにする */
  color: #424242;
  font-weight: 500;
}

.feature-row_product_list {
  align-items: inherit;
}
.feature-row_product_item {
  width: 33%;
  padding: 5px;
  text-align: center;
}
.feature-row_product_detail {
  color: #333;
}
.feature-row_product_cate {
  font-size: .8em;
  color: #6b6b67;
  opacity: .65;
}

.feature-row_voice_list {
  align-items: baseline;
}
.feature-row_voice_list path.a {
  fill: none;
  stroke: #000;
  stroke-width: 2px;
}
.feature-row_voice_list .icon svg {
  width: 70px;
}
.feature-row_voice_list .feature-row_voice_item {
  width: 33%;
  padding: 5px;
  text-align: center;
}

.box-top-slide {
  position: relative;
}
.img-top-slide_text {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 30px;
}
.img-top-slide_text h2 {
  font-size: 2em;
  font-weight: 500 !important;
}
.img-top-slide_text h2 span {
  font-size: .6em;
}

.layer_02 .layer-text {
  background-color: #cacaca;
  padding: 10px;
}
.layer_02 .layer-text .layer-text-inner {
  background-color: #fff;
  padding: 15px;
}
.layer_02 .layer-text .layer-text-inner h2 span {
  font-size: .6em;
}
@media screen and (min-width: 991px) {
    .layer_02 {
      position: relative;
      display: flex;
      align-items: center;
      background-image: url('../../assets/img/column/202407_10.jpg');
      background-size: cover;
      min-height: 500px; /* 最小高さを設定しておくと、極端に小さくなるのを防げます */
      padding: 60px; /* テキストと画像の端の間に余白を設定 */
    }
    .layer_02 img {
      display: none; /* 画像は背景として使用するので非表示にします */
    }
    .layer_02 .layer-text {
      padding: 15px;
      max-width: 90%; /* 文字が画像からはみ出さないように最大幅を設定 */
      word-wrap: break-word; /* 長い単語が折り返されるようにする */
      color: #424242;
      background-color: #fff;
    }
}
@media screen and (max-width: 699px) {
   .img-top-slide_text {
      top: 40%;
      left: 15px;
      right: 15px;
      width: 185px;
    }
    .img-top-slide_text h2 {
      font-size: inherit;
    }
    .img-top-slide_text h2 span {
      font-size: .8em;
    }
}
@media screen and (min-width: 769px) {
   .feature-row_item_text_right {
    padding-left: 60px;
   }
   .feature-row_item_text_left {
    padding-right: 60px;
   }
   .w-40 {
    width: 40%;
   }
   .w-60 {
    width: 60%;
   }

}
@media screen and (min-width: 1px) and (max-width: 768px) {
  .column_content h2 {
    margin-bottom: 40px;
  }
  .feature-row {
    flex-direction: column;
  }
  .feature-row_item_image {
    order: 1;
    margin-bottom: 15px;
  }
  .feature-row_item_text {
    order: 2;
  }
  .feature-row_voice_item, .feature-row_product_item {
      width: 100% !important;
  }
  .w-50, .w-25, .w-75 {
    width: 100% !important;
  }
  .layer-text {
    font-size: .8em;
  }
}
</style>

<script>
import $ from "jquery";

$(function() {
 var topBtn = $('#page-top');    
 topBtn.hide();
 //スクロールが500に達したらボタン表示
 $(window).scroll(function () {
 if ($(this).scrollTop() > 500) {
 topBtn.fadeIn();
        } else {
 topBtn.fadeOut();
        }
    });
    
});

// ページ内リンク
export default{
  data: () => {
    return {isActive: []}
  },
  mounted (){
    window.scroll(0, 0);
    for(let i = 0; i < 2; i++) {
      this.isActive[i] = false
    }
  },
  methods: {
    scrollToAnchorPoint(refName) {
      const el = this.$refs[refName]
      el.scrollIntoView({ behavior: 'smooth'})
    },
    openInfo(ref) {
      console.log(ref)
      this.isActive[ref] = true
      console.log(this.isActive[ref])
    },
    closeInfo(ref) {
      console.log(ref)
      this.isActive[ref] = false
      console.log(this.isActive[ref])
    },
    scrollTop(){
      window.scrollTo({
      top: 0,
      behavior: "smooth"
      })
    }
  }
}

</script>